// extracted by mini-css-extract-plugin
module.exports = {"loadContainer":"Loaderv2-module__loadContainer","loader":"Loaderv2-module__loader","rotation":"Loaderv2-module__rotation","smallLoader":"Loaderv2-module__smallLoader"};